import { TOMATO_RED } from '@propertypal/shared/src/styles/theme';
import styled from 'styled-components';

export const RangeLine = styled.div`
  width: 254px;
  height: 1px;
  background-color: ${({ theme }) => theme.backgroundMid};
  position: relative;
`;

export const RangeMarker = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  border-left: 1px solid ${({ theme }) => theme.backgroundMid};
`;

export const StartMarker = styled(RangeMarker)`
  left: 0;
  top: -5px;
`;
export const MiddleMarker = styled(RangeMarker)`
  left: 50%;
  top: -5px;
`;
export const EndMarker = styled(RangeMarker)`
  right: -9px;
  top: -5px;
`;

export const MarkerTextWrapper = styled.span`
  font-size: 11px;
  text-align: center;
  width: 55px;
  position: absolute;
  line-height: 1;
  margin-top: 8px;
`;

export const LowerEstimateText = styled(MarkerTextWrapper)`
  left: -28px;
`;

export const HigherEstimateText = styled(MarkerTextWrapper)`
  right: -28px;
`;

export const EstimateValueWrapper = styled.span`
  width: 82px;
  display: block;
  font-size: 18px;
  font-weight: bold;
  color: ${TOMATO_RED};
  position: absolute;
`;

export const LowerEstimateValue = styled(EstimateValueWrapper)`
  left: -26px;
  top: -35px;
`;

export const HigherEstimateValue = styled(EstimateValueWrapper)`
  right: -56px;
  top: -35px;
`;

export const MiddleEstimateValue = styled(EstimateValueWrapper)`
  left: 101px;
  top: -35px;
`;
